export function Card({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <section
      className={`rounded-2xl border border-slate-200 bg-white p-6 shadow-card ${className}`}
    >
      {children}
    </section>
  );
}

export function CardHeader({
  title,
  icon,
  action,
}: {
  title: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        {icon && (
          <span className="grid h-7 w-7 place-items-center rounded-lg bg-slate-100 text-slate-600">
            {icon}
          </span>
        )}
        <h2 className="text-sm font-semibold uppercase tracking-wider text-slate-700">
          {title}
        </h2>
      </div>
      {action}
    </div>
  );
}
